import request from '@/utils/request'

// 生存环境

// 获取验证码
export function getCode (data) {
  return request({
    data: data,
    url: '/api/regsms',
    method: 'post'
  })
}

// 开发环境api路径

// export function getCode (data) {
//   return request({
//     data: data,
//     url: 'api/api/regsms',
//     method: 'post'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/registered.js